module.exports = __webpack_public_path__ + "img/welcome.086e5248.png";